import { IApiResponse } from "../../models/IAPIResponse";
import { IDescriptionData, IDescriptions } from "../../models/master/descriptions";
import { urlBinder } from "../../helper/url-binder";
import { description } from "../../constants/apiUrl";
import APIService from "../../helper/api-service";


export default new (class descriptionService {

    public getDescription = async (
        id: number
    ): Promise<IApiResponse<IDescriptionData>> => {
        try {
            let endPoint = urlBinder(description.GET_DESCRIPTION, [`${id}`]);
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<IDescriptionData>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<IDescriptionData>;
            } else {
                throw error;
            }
        }
    };

    public getAllDescription = async (
        configUserRole?: number,
        pageBlockId?: number,
        noOfItems?: number,
    ): Promise<IApiResponse<Array<IDescriptions>>> => {
        try {
            let endPoint = urlBinder(description.GET_ALL_DESCRIPTIONS, [configUserRole, pageBlockId, noOfItems]);
            const response = await APIService.get(endPoint);
            return response.data as IApiResponse<Array<IDescriptions>>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<Array<IDescriptions>>;
            } else {
                throw error;
            }
        }
    };

    public createDescription = async (
        data: any
    ): Promise<IApiResponse<boolean | any>> => {
        try {
            let endPoint = description.CREATE_DESCRIPTION;
            const response = await APIService.postFormData(endPoint, data);
            return response.data as IApiResponse<boolean | any>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<boolean | any>;
            } else {
                throw error;
            }
        }
    };

    public updateDescription = async (
        data: IDescriptionData, id: number
    ): Promise<IApiResponse<boolean>> => {
        try {
            let endPoint = urlBinder(description.UPDATE_DESCRIPTION, [`${id}`]);
            const response = await APIService.put(endPoint, data);
            return response.data as IApiResponse<boolean>;
        } catch (error: any) {
            if (error.response) {
                return error.response as IApiResponse<boolean>;
            } else {
                throw error;
            }
        }
    };

    public deleteDescription = async (id: number): Promise<boolean> => {
        try {
            let endPoint = urlBinder(description.DELETE_DESCRIPTION, [`${id}`]);
            const response = await APIService.delete(endPoint);
            return response.status === 204 ? true : false;
        } catch (error: any) {
            if (error.response) {
                return false as boolean;
            } else {
                throw error;
            }
        }
    };

})();